import React from 'react';
import { cn } from '../../lib/utils';

// Interruptor (estilo iOS/Android) para consentimentos do cadastro.
// A linha inteira é um único botão: funciona no toque do celular sem depender
// da caixa de seleção nativa do navegador.
export const ConsentSwitch = ({
  checked,
  onChange,
  children,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: React.ReactNode;
}) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    onClick={() => onChange(!checked)}
    className="relative z-10 flex w-full items-center justify-between gap-3 rounded-lg border border-white/10 bg-white/[0.03] px-3 py-3 text-left transition hover:bg-white/[0.06] active:bg-white/[0.08] touch-manipulation cursor-pointer select-none focus:outline-none focus-visible:ring-2 focus-visible:ring-[#00ffa3]/60"
  >
    <span className="text-[9px] uppercase leading-normal tracking-wider text-white/70">{children}</span>
    <span
      aria-hidden="true"
      className={cn(
        'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border transition-colors duration-200 ease-in-out',
        checked
          ? 'border-[#00ffa3] bg-[#00ffa3] shadow-[0_0_12px_rgba(0,255,163,0.55)]'
          : 'border-white/20 bg-[#111827]'
      )}
    >
      <span
        className={cn(
          'inline-block h-5 w-5 transform rounded-full bg-white shadow transition duration-200 ease-in-out',
          checked ? 'translate-x-[21px]' : 'translate-x-[1px]'
        )}
      />
    </span>
  </button>
);
